var _defs, _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackgroundLogin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "162.76mm",
    height: "91.64mm",
    clipRule: "evenodd",
    fillRule: "evenodd",
    imageRendering: "optimizeQuality",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    viewBox: "0 0 4633.5 2608.8",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n            .str0 {stroke:#3E4095;stroke-width:5.69;stroke-miterlimit:22.9256}\n            .fil0 {fill:#3E4095}\n            .fil1 {fill:#FEFEFE}\n        "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "fil0 str0",
    x: 2.85,
    y: 2.85,
    width: 4627.8,
    height: 2603.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "m2134.8 1239.7c6.96-11.85 19.57-19.19 33.3-19.19 13.74 0 26.34 7.34 33.3 19.19l111.57 192.66c3.38 5.83 5.27 12.61 5.27 19.38 0 21.26-17.31 38.57-38.57 38.57h-223.33c-21.26 0-38.57-17.31-38.57-38.57 0-6.77 1.88-13.35 5.27-19.38l111.57-192.66h0.18z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "m2418.1 1337.5c6.95-11.85 19.56-19.19 33.3-19.19s26.34 7.34 33.3 19.19l125.68 217.13c3.38 5.83 5.27 12.42 5.27 19.19 0 21.26-17.31 38.57-38.38 38.57h-251.36c-21.26 0-38.57-17.31-38.57-38.57 0-6.77 1.88-13.35 5.27-19.19l125.68-217.13h-0.19z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "m2376.4 1373.1c-6.96 11.85-19.57 19.19-33.3 19.19-13.74 0-26.34-7.34-33.3-19.19l-184.95-318.72c-3.38-5.83-5.27-12.61-5.27-19.38 0-21.26 17.31-38.57 38.57-38.57h370.09c21.26 0 38.57 17.31 38.57 38.57 0 6.77-1.88 13.55-5.27 19.38l-184.95 318.72h-0.19z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundLogin);
export default __webpack_public_path__ + "static/media/background-login.e2fe92abe7b34b1937cb6ebb0a5fc996.svg";
export { ForwardRef as ReactComponent };